export const clockCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M12 0a12 12 0 1 0 12 12A12.014 12.014 0 0 0 12 0m0 22a10 10 0 1 1 10-10 10.01 10.01 0 0 1-10 10m5.134-6.19L12.5 11.561V6.5a1 1 0 0 0-2 0V12a1 1 0 0 0 .324.738l4.959 4.545a1.01 1.01 0 0 0 1.413-.061 1 1 0 0 0-.062-1.412"/></svg>`,
    name: 'clock-circle'
};